import type { FC, ReactNode } from 'react';

import { getSourceEventParams, useAmplitude } from '@crehana/analytics';
import { Checkbox, AvatarUser as NewAvatarUser } from '@crehana/compass.ui';
import { useRouter } from 'next/router';

interface AvatarUserProps {
  name?: string | null;
  avatar?: string;
  isDark?: boolean;
  username?: string | null;
  checked?: boolean;
  hideAvatar?: boolean;
  numeration?: ReactNode;
  disabledCheckbox?: boolean;
  navigateUrl?: string;
  onChange?: () => void;
  onNavigate?: () => void;
}

const AvatarUser: FC<React.PropsWithChildren<AvatarUserProps>> = ({
  name,
  avatar,
  username,
  checked,
  hideAvatar,
  numeration,
  disabledCheckbox,
  navigateUrl,
  onChange,
  onNavigate,
}) => {
  const { query } = useRouter();
  const { logEvent } = useAmplitude();
  const { slug } = query as { slug: string };

  const navigateDetailUser = () => {
    if (username || navigateUrl) {
      logEvent({
        event: 'Navigate user detail',
        data: {
          ...getSourceEventParams(),
        },
      });

      const url =
        navigateUrl ||
        `/org/${slug}/panel/estadisticas/especificas/${username}/`;
      window.open(url, '_blank');
    }
  };

  return (
    <div className="tw-flex">
      {onChange && (
        <Checkbox
          disabled={disabledCheckbox}
          checked={checked}
          onChange={onChange}
          className={!numeration ? 'tw-mr-0.8' : ''}
          size="m"
        />
      )}
      {numeration && (
        <div
          className={
            'tw-flex tw-items-center tw-font-link3 tw-pl-1 dark:tw-text-neutral-light-100 tw-text-neutral-light-700'
          }
        >
          {numeration}
        </div>
      )}
      <NewAvatarUser
        onClick={onNavigate || navigateDetailUser}
        avatar={!hideAvatar ? avatar : undefined}
        fullName={name}
      />
    </div>
  );
};

export default AvatarUser;
